import { Coordinate } from './Geo/Coordinate.js';

/**
 * The default center coordinate, currently in Dearing, KS, in the middle
 * of the United States
 * @type {Coordinate}
 */
export const defaultCenterCoordinate = new Coordinate(37.0902, -95.7129);
